import { BillingDto, ModificaStatoAvanzamentoRequest } from '@api/client';
import { useAppDispatch } from 'core/store/hooks';
import { getBillingPlan, updateStatoAvanzamentoBilling } from '../_redux/actions';
import { useState } from 'react';
import { EditableStatoAvanzamentoLavori } from './useEditBill';

const useSaveBill = (
  projectId: number,
  setIsBillingDirty: React.Dispatch<React.SetStateAction<boolean>>,
  setBillingPlan: React.Dispatch<React.SetStateAction<BillingDto[] | undefined>>
) => {
  const dispatch = useAppDispatch();
  const [errors, setErrors] = useState<Record<string, { date: boolean; block: boolean; amount: boolean }>>({});

  const handleSaveBill = (billing: BillingDto, sal: EditableStatoAvanzamentoLavori) => {
    const payload: ModificaStatoAvanzamentoRequest = {
      statoAvanzamentoLavoriDto: {
        id: sal.id,
        idInvoiceMilestone: billing.id,
        isInviato: sal.isInviato,
        dataDiInvio: sal.dataDiInvio,
        tipologiaBlocco: sal.idTipologiaBlocco?.value,
        importo: Number(sal.importo),
      },
    };
    dispatch(updateStatoAvanzamentoBilling(payload))
      .unwrap()
      .then(() => {
        setIsBillingDirty(false);
        // Il salvataggio di una riga bozza (sal.id era undefined) la fa diventare un record BE
        // reale, ma il refetch che segue è ricostruito in useGetBillingData a partire anche dalle
        // bozze locali residue (per non perdere le bozze di ALTRE milestone/righe non coinvolte
        // in questo salvataggio): se non rimuoviamo qui la bozza appena salvata, sopravvivrebbe
        // nello stato locale duplicata insieme alla riga reale appena arrivata dal BE.
        if (sal.id === undefined) {
          setBillingPlan((prev) =>
            prev?.map((item) =>
              item.id === billing.id
                ? {
                    ...item,
                    statoAvanzamentoLavoriList: item.statoAvanzamentoLavoriList?.filter(
                      (row) => (row as EditableStatoAvanzamentoLavori).tempId !== sal.tempId
                    ),
                  }
                : item
            )
          );
        }
        dispatch(getBillingPlan(projectId));
      });
  };

  const handleSaveWithValidation = (billing: BillingDto, sal: EditableStatoAvanzamentoLavori) => {
    const newErrors = {
      date: !sal.dataDiInvio,
      block: !sal.idTipologiaBlocco?.value,
      amount: !sal.importo,
    };

    const salRowKey = String(sal.id ?? sal.tempId);

    setErrors((prev) => ({ ...prev, [salRowKey]: { ...newErrors } }));

    if (!newErrors.date && !newErrors.block && !newErrors.amount) {
      handleSaveBill(billing, sal);
    }
  };

  return { errors, handleSaveWithValidation };
};

export default useSaveBill;
